import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-checkmark",
  "use": "icon-circle-checkmark-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-circle-checkmark\"><path d=\"M5 8.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z\" fill=\"#111921\" stroke=\"#111921\" stroke-width=\".75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M6.719 3.75 4.426 5.938 3.28 4.843\" stroke=\"#fff\" stroke-width=\".75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol